module.exports = __webpack_public_path__ + "static/media/confirmation.54ce86da.svg";